import ModalFacetWrapper from './FacetWrapper';

export default ModalFacetWrapper;
